/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2TreatmentExams/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2TreatmentExams({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2TreatmentExams",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2TreatmentExams.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-ZUjBp9': alignSelf,'--mt-2-ZUjBp9': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZUjBp9': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZUjBp9': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZUjBp9': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZUjBp9': opacity,'--w-10-ZUjBp9': typeof width === 'number' ? `${width}px` : width,'--h-11-ZUjBp9': typeof height === 'number' ? `${height}px` : height,'--f-12-ZUjBp9': fill,'--a-7-ZUjBp9': isAnimated ? animation : "none",'--sd-8-ZUjBp9': isAnimated ? strokeDashoffset : 0,'--sd-9-ZUjBp9': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2TreatmentExams.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.249.219C.559.219 0 .778 0 1.467V7.97C0 8.66.56 9.22 1.249 9.22H4.7L4.241 10.5H3.43a.643.643 0 100 1.286H8.57a.643.643 0 000-1.286H7.76L7.3 9.22h3.451c.69 0 1.249-.56 1.249-1.249V1.467C12 .777 11.441.22 10.751.22H1.25zm3.883 2.28c0-.186.15-.337.337-.337h1.093c.185 0 .336.15.336.337v1.337h1.337c.186 0 .337.15.337.336v1.093c0 .186-.151.336-.337.336H6.898V6.94c0 .186-.15.336-.336.336H5.469a.336.336 0 01-.337-.336V5.6H3.795a.336.336 0 01-.336-.336V4.172c0-.185.15-.336.336-.336h1.337V2.499z"
 style={{'--f-12-ZUjBp9': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}